import type { InterfaceLanguage } from '@/types';

/** Shipped in the bundle; used when the backend does not send a list of its own. */
export const BUNDLED_LANGUAGES: InterfaceLanguage[] = [
  { code: 'en', name: 'English' },
  { code: 'ru', name: 'Русский' },
];

const SUPPORTED_LOCALES = BUNDLED_LANGUAGES.map((language) => language.code);

export const getLocale = (): string => {
  const savedLocale = localStorage.getItem('locale');

  if (savedLocale && SUPPORTED_LOCALES.includes(savedLocale)) {
    return savedLocale;
  }

  const browserLocale = navigator.language?.split('-')[0];

  return SUPPORTED_LOCALES.includes(browserLocale) ? browserLocale : 'en';
};

export const setLocale = (locale: string) => {
  localStorage.setItem('locale', locale);
};

/**
 * Which locale to switch to when the current one is no longer offered.
 * Returns null when the current one is fine or the list has not arrived yet.
 */
export const pickAllowedLocale = (
  current: string,
  allowed: string[],
  fallback: string,
): string | null => {
  if (!allowed.length || allowed.includes(current)) {
    return null;
  }

  return allowed.includes(fallback) ? fallback : allowed[0];
};

/**
 * A backend that does not send the list yet leaves the bundled languages on offer,
 * so the frontend can be deployed before the backend that limits them.
 */
export const languagesToOffer = (fromBackend?: InterfaceLanguage[]): InterfaceLanguage[] =>
  fromBackend?.length ? fromBackend : BUNDLED_LANGUAGES;
